// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cash-flow-report__cell--header,\n.cash-flow-report__cell--footer {\n  background-color: #2F64A3;\n  color: #fff;\n}\n.cash-flow-report__th--lg {\n  font-size: 16px;\n  font-weight: 600 !important;\n}\n", ""]);
// Exports
module.exports = exports;
